import styled from "styled-components";

export const UserPageContainer = styled.div`
  height: 93vh;
  color: white;
  display: flex;
  border: 1px solid red;
  flex-direction: column;

  & h1 {
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

export const UserSettingsWrapper = styled.div`
  border: 1px solid red;
  display: flex;
  height: 90%;
`;

export const UserSettingsSidebar = styled.aside`
  border: 1px solid red;
  flex: 0.2;
`;

export const UserDetails = styled.div`
  border: 1px solid red;
  flex: 0.8;
`;

export const UserDetailsHeader = styled.div`
  border: 1px solid red;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserImage = styled.div`
  width: 15%;
  height: 300px;
  background: blue;
`;

export const UserDetailsMain = styled.div`
  border: 1px solid red;
  height: 40%;
`;
